export default __webpack_public_path__ + "static/media/building1.2ba3763f.svg";